import React from 'react';
import styles from '@dazn/lp-web/src/components/BannerSlider/MobileSlider/mobile-slider.module.css';
import classnames from 'classnames';
import classNames from 'classnames';
interface IPaginationProps {
    activeIndex: number;
    count: number;
    isRotatingContentBanner: boolean
}

const Pagination: React.FC<IPaginationProps> = ({
    activeIndex,
    count,
    isRotatingContentBanner
}: any) => {
    return (
        <div className={classNames(styles.pagination, {
                [styles.rotatingBannerPagination]: isRotatingContentBanner
        })}>
            {Array(count)
                .fill(0)
                .map((_, i) => (
                    <button
                        key={i}
                        className={classnames({
                            [styles.active]: i === activeIndex
                        })}
                    />
                ))}
        </div>
    );
};

export default Pagination;
